/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DataRefreshIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Data Refresh',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <ellipse cx="18" cy="7" rx="16" ry="5" />
    <path
      d="M14.8 30.2v-3.3a9.618 9.618 0 0 1 .116-1.1 13.076 13.076 0 0 1 .371-1.624C10.233 23.846 3.5 22.644 2 20.27V29c0 2.419 5.5 4.436 12.8 4.9ZM27 14.8a12.115 12.115 0 0 1 6.3 1.85l.415-.424.285-.292V10.27c-2.447 3.095-11.064 4-16 4s-14.212-1.168-16-4V17c0 2.56 6.158 4.667 14.094 4.961A12.173 12.173 0 0 1 27 14.8ZM27 33.435a6.212 6.212 0 0 1-4.771-2.123L24.537 29H18v6.55l2.5-2.509A8.744 8.744 0 0 0 27 36a9.3 9.3 0 0 0 9-9h-2.28A6.889 6.889 0 0 1 27 33.435Z"
    />
    <path
      d="M33.558 20.958A9.215 9.215 0 0 0 27 18a9.3 9.3 0 0 0-9 9h2.28A6.889 6.889 0 0 1 27 20.565a6.283 6.283 0 0 1 4.871 2.116L29.6 25H36v-6.535Z"
    />
  </svg>`;
};
